"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
module.exports = angular.module('backstage.components.common.server-selection', []).component('bsServerSelection', {
  template: "        <div class=\"bs-server-selection\">\n            <select class=\"input-large\"\n                    ng-model=\"vm.group\"\n                    required\n                    ng-options=\"group as groupName\n                                for (group, groupName) in vm.servers\"\n                    ng-change=\"vm.onSelectedRegionChange()\">\n            </select>\n        </div>        ",
  controller:
  /*#__PURE__*/
  /* @ngInject */
  function () {
    BsServerSelectionViewModel.$inject = ["$window", "serverService", "$scope"];
    function BsServerSelectionViewModel($window, serverService, $scope) {
      var _this = this;
      _classCallCheck(this, BsServerSelectionViewModel);
      this.$window = $window;
      this.serverService = serverService;
      $scope.$watch('vm.org', function () {
        if (!_this.org) {
          return;
        }
        return _this.loadServers().then(function (servers) {
          return _this.servers = servers;
        });
      });
    }
    return _createClass(BsServerSelectionViewModel, [{
      key: "onSelectedRegionChange",
      value: function onSelectedRegionChange() {
        return this.groupName = this.servers[this.group];
      }
    }, {
      key: "loadServers",
      value: function loadServers() {
        var split = this.org.split(':');
        return this.serverService.getOrgServers(split[1]);
      }
    }]);
  }(),
  controllerAs: 'vm',
  bindings: {
    group: '=',
    groupName: '=',
    org: '=',
    stage: '='
  }
}).name;